<template>
  <product-reviews-summary v-if="product?.rating" :product :reviews-data="reviewsData" />
</template>

<script setup lang="ts">
const { product, reviewsData } = usePdp()
</script>
